import { render, staticRenderFns } from "./rtc-pricing.vue?vue&type=template&id=02b740de&"
import script from "./rtc-pricing.vue?vue&type=script&lang=js&"
export * from "./rtc-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports